import React from 'react';
import { Form, Input, InputNumber, Button, TimePicker, Tooltip, Icon, Radio } from 'antd';
import PropTypes from 'prop-types';
import { StyledContainer } from './styled';

function CapacityForm({ form, onSubmit }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, form);
  };

  const handleCndAbility = (event) =>
    form.setFieldsValue({
      maxCnd: event.target.value === 'no' ? 0 : 1,
    });

  const { getFieldDecorator, getFieldValue } = form;

  return (
    <StyledContainer>
      <Form colon={false} labelCol={{ span: 5 }} wrapperCol={{ span: 12 }} onSubmit={handleSubmit}>
        <h2>Capacity Details</h2>
        <Form.Item label={<span>MOT Lead time</span>}>
          {getFieldDecorator('motLeadTime', {})(<InputNumber min={0} max={100} />)}
        </Form.Item>
        <Form.Item label={<span>Repairs & Services Lead time</span>}>
          {getFieldDecorator('repairsLeadTime', {})(<InputNumber min={0} max={100} />)}
        </Form.Item>
        <Form.Item
          label={
            <span>
              Default Daily MOT Capacity
              <Tooltip title="How many MOT bookings can be allocated to this garage per day?">
                <Icon type="info-circle" theme="outlined" />
              </Tooltip>
            </span>
          }
        >
          {getFieldDecorator('defaultMotCapacity', {
            rules: [
              {
                required: true,
                message:
                  // eslint-disable-next-line max-len
                  'Please select the maximum amount of MOT bookings that can be allocated to this garage per day.',
              },
            ],
          })(<InputNumber min={0} max={500} />)}
        </Form.Item>

        <Form.Item
          label={
            <span>
              Default Daily Repairs & Services Capacity
              <Tooltip title=
              // eslint-disable-next-line max-len
              "How many Repairs & Service bookings can be allocated to this garage per day?">
                <Icon type="info-circle" theme="outlined" />
              </Tooltip>
            </span>
          }
        >
          {getFieldDecorator('defaultRepairsCapacity', {
            rules: [
              {
                required: true,
                message:
                  // eslint-disable-next-line max-len
                  'Please select the maximum amount of Repairs & Service bookings that can be allocated to this garage per day.',
              },
            ],
          })(<InputNumber min={0} max={500} />)}
        </Form.Item>

        <Form.Item
          name="radio-group"
          label="Can the garage carry out C&D?"
          onChange={(e) => handleCndAbility(e)}
          initialValue="yes"
        >
          {getFieldDecorator('cndCapable', { initialValue: getFieldValue('maxCnd') ? 'yes' : 'no' })(
            <Radio.Group>
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </Radio.Group>
          )}
        </Form.Item>

        <Form.Item
          style={{ display: getFieldValue('cndCapable') === 'no' && 'none' }}
          label={
            <span>
              Daily C&D Capacity
              <Tooltip title="How many vehicles can the garage provide C&D for per day?">
                <Icon type="info-circle" theme="outlined" />
              </Tooltip>
            </span>
          }
          rules={[{ required: true }]}
        >
          {getFieldDecorator('maxCnd', {
            rules: [
              {
                required: true,
                message:
                  // eslint-disable-next-line max-len
                  'Please select the maximum amount of Garage C&D bookings that can be allocated to this garage per day.',
              },
              {
                validator(rule, value) {
                  if (value > (getFieldValue('defaultMotCapacity') + getFieldValue('defaultRepairsCapacity')))
                    return Promise.reject(
                      Error('The Daily C&D Capacity can not exceed the sum of the MOT + Repairs capacity.')
                    );
                  return Promise.resolve();
                },
              },
            ],
          })(<InputNumber min={0} max={500} />)}
        </Form.Item>

        <Form.Item
          label={
            <span>
              C&D Type
              <Tooltip title="The C&D type will be recalculated and shown here once your changes are saved.">
                <Icon type="info-circle" theme="outlined" />
              </Tooltip>
            </span>
          }
        >
          {getFieldDecorator('garageDeliveryOption', {})(<Input disabled />)}
        </Form.Item>

        <Form.Item label="Vehicle Weight Capacity (KG)" rules={[{ required: true }]}>
          {getFieldDecorator('vehicleWeightCapacity', {
            rules: [{ required: true, message: 'Please select a weight capacity between 3000 and 3500 KG.' }],
          })(<InputNumber min={3000} max={3500} />)}
        </Form.Item>

        <Form.Item label="Opening Time" rules={[{ required: true }]}>
          {getFieldDecorator('openingHour', {
            rules: [{ required: true, message: 'Please select a valid opening time.' }],
          })(<TimePicker use12Hours format="h:mm a" />)}
        </Form.Item>

        <Form.Item label="Closing Time" rules={[{ required: true }]}>
          {getFieldDecorator('closingHour', {
            rules: [{ required: true, message: 'Please select a valid closing time.' }],
          })(<TimePicker use12Hours format="h:mm a" />)}
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12 }}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </StyledContainer>
  );
}

CapacityForm.propTypes = {
  form: PropTypes.any.isRequired,
  onSubmit: PropTypes.any.isRequired,
};

export default (mapPropsToFields) => Form.create({ name: 'capacity', mapPropsToFields })(CapacityForm);
